import idx from 'idx'
import { subDays } from 'date-fns'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {downloadDataAsCsv} from 'utils/files'
import {compose, withHandlers, withStateHandlers, lifecycle} from 'recompose'
import withMixpanel, {EXPORT_DATA_BUTTON_CLICK, EXPORT_DATA_GROUP_REPORT, EXPORT_DATA_TRAP_REPORT} from 'utils/mixpanel'

import {TRAP_DATA, GROUP_DATA} from 'constants/form'

import * as trapModule from 'modules/trap'
import * as groupModule from 'modules/group'
import {generateStrikesCsvReport} from "modules/trap";

// NOTE: Done a quick and dirty repurposing of this unused popup, so names aren't what they should be

export default compose(
    withMixpanel,
    connect(
        (state) => {
          return {
            organisation: idx(state, _ => _.organisation.selected)
          }
        },
        (dispatch) => {
      const actions = {
        ...trapModule,
        ...groupModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    ({ data }) => {
      return {
        type: GROUP_DATA,
        endDate: new Date(),
        startDate: subDays(new Date(), data.selectedRange ? data.selectedRange.value : 30)
      }
    },
    {
      setExportType: () => type => ({
        type
      }),
      setEndDate: () => endDate => ({
        endDate
      }),
      setStartDate: () => startDate => ({
        startDate
      })
    }
  ),
  withHandlers({
    onExportClick: ({
                      track, type, actions, organisation, startDate, endDate, handleClose
                    }) => () => {
      if (type === GROUP_DATA) {
        track(EXPORT_DATA_GROUP_REPORT)
          actions.generateSummaryCsvReport(organisation, (result) => {
              handleClose()
              downloadDataAsCsv(result, `${organisation.name} summary data`)
          })
      } else if (type === TRAP_DATA) {
        track(EXPORT_DATA_TRAP_REPORT)
        actions.generateStrikesCsvReport(organisation, (result) => {
          handleClose()
          downloadDataAsCsv(result, `${organisation.name} kill data`)
        })
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.track(EXPORT_DATA_BUTTON_CLICK)
    }
  })
)



// WEBPACK FOOTER //
// ./src/components/organisms/ExportDataForm/ExportDataForm.enhancer.js